/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A datetime string with format `Y-m-d`, e.g. `2018-05-23`. */
  Date: { input: any; output: any; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any; }
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  Mixed: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  expiresIn: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
  type: Scalars['ID']['output'];
};

export type Amount = {
  __typename?: 'Amount';
  currency: Currency;
  value: Scalars['Float']['output'];
  visible: Scalars['String']['output'];
};

export type ApplyCodeInput = {
  code: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export enum AuthenticateAction {
  Login = 'LOGIN',
  Register = 'REGISTER',
  Upgrade = 'UPGRADE'
}

export type AuthenticateWithThirdPartyInput = {
  /**
   * How much second passed before using the register operation?
   * Only required if the action is REGISTER.
   */
  acceptPrivacyPolicies?: InputMaybe<Scalars['Int']['input']>;
  /**
   * How much second passed before using the register operation?
   * Only required if the action is REGISTER.
   */
  acceptTermsAndConditions?: InputMaybe<Scalars['Int']['input']>;
  action: AuthenticateAction;
  provider: ThirdPartyProvider;
};

export type AuthenticateWithThirdPartyOutput = {
  __typename?: 'AuthenticateWithThirdPartyOutput';
  redirectTo: Scalars['String']['output'];
};

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  user: User;
};

export type AuthenticationTokens = {
  __typename?: 'AuthenticationTokens';
  access: AccessToken;
  refresh: RefreshToken;
};

export type CallQueueItem = {
  __typename?: 'CallQueueItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: CallQueueItemStatus;
  user?: Maybe<User>;
};

/** A paginated list of CallQueueItem items. */
export type CallQueueItemPaginator = {
  __typename?: 'CallQueueItemPaginator';
  /** A list of CallQueueItem items. */
  data: Array<CallQueueItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CallQueueItemStatus = {
  __typename?: 'CallQueueItemStatus';
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
};

export type Capability = {
  __typename?: 'Capability';
  allowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  secondsLeft?: Maybe<Scalars['Int']['output']>;
};

export type ClearDrawResultInput = {
  /** Draw identifier. */
  id: Scalars['ID']['input'];
};

export type Code = {
  __typename?: 'Code';
  area?: Maybe<Scalars['String']['output']>;
  belongsTo?: Maybe<Station>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * If the code is related to an invoice this should be populated.
   * As we still don't know which are the related fields, this attribute
   * should be added.
   */
  invoice?: Maybe<Invoice>;
  label: Scalars['ID']['output'];
  multiplier: Scalars['Int']['output'];
  /**
   * All the opportunities related to the code. This should be used
   * in the administrator context.
   */
  opportunities: Array<Opportunity>;
  options: Scalars['Int']['output'];
  products?: Maybe<Array<Product>>;
  /** @deprecated Use the belongsTo attribute */
  station?: Maybe<Scalars['String']['output']>;
  /** Invoice, gift, promotional code, etc. */
  type: CodeCategory;
  /** All the opportunities related to the code and the user in the request. */
  userOpportunities: Array<Opportunity>;
  /** Which coupons are related with this transaction. */
  visible?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};


export type CodeOpportunitiesArgs = {
  hasCode?: InputMaybe<CodeOpportunitiesHasCodeWhereHasConditions>;
  orderBy?: InputMaybe<Array<CodeOpportunitiesOrderByOrderByClause>>;
  where?: InputMaybe<CodeOpportunitiesWhereWhereConditions>;
};


export type CodeUserOpportunitiesArgs = {
  hasCode?: InputMaybe<CodeUserOpportunitiesHasCodeWhereHasConditions>;
  orderBy?: InputMaybe<Array<CodeUserOpportunitiesOrderByOrderByClause>>;
  where?: InputMaybe<CodeUserOpportunitiesWhereWhereConditions>;
};

export type CodeCategory = {
  __typename?: 'CodeCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Allowed column names for Code.opportunities.hasCode. */
export enum CodeOpportunitiesHasCodeColumn {
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type CodeOpportunitiesHasCodeWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<CodeOpportunitiesHasCodeWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<CodeOpportunitiesHasCodeWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<CodeOpportunitiesHasCodeWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<CodeOpportunitiesHasCodeColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type CodeOpportunitiesHasCodeWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<CodeOpportunitiesHasCodeWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Code.opportunities.orderBy. */
export enum CodeOpportunitiesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Label = 'LABEL'
}

/** Order by clause for Code.opportunities.orderBy. */
export type CodeOpportunitiesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: CodeOpportunitiesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Code.opportunities.where. */
export enum CodeOpportunitiesWhereColumn {
  Label = 'LABEL',
  Status = 'STATUS',
  UserId = 'USER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `opportunities`. */
export type CodeOpportunitiesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<CodeOpportunitiesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<CodeOpportunitiesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<CodeOpportunitiesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<CodeOpportunitiesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `opportunities`. */
export type CodeOpportunitiesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<CodeOpportunitiesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** A paginated list of Code items. */
export type CodePaginator = {
  __typename?: 'CodePaginator';
  /** A list of Code items. */
  data: Array<Code>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Allowed column names for Code.userOpportunities.hasCode. */
export enum CodeUserOpportunitiesHasCodeColumn {
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `hasCode` argument of the query `userOpportunities`. */
export type CodeUserOpportunitiesHasCodeWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<CodeUserOpportunitiesHasCodeWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<CodeUserOpportunitiesHasCodeWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<CodeUserOpportunitiesHasCodeWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<CodeUserOpportunitiesHasCodeColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasCode` argument of the query `userOpportunities`. */
export type CodeUserOpportunitiesHasCodeWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<CodeUserOpportunitiesHasCodeWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Code.userOpportunities.orderBy. */
export enum CodeUserOpportunitiesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Code.userOpportunities.orderBy. */
export type CodeUserOpportunitiesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: CodeUserOpportunitiesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Code.userOpportunities.where. */
export enum CodeUserOpportunitiesWhereColumn {
  Code = 'CODE',
  Status = 'STATUS'
}

/** Dynamic WHERE conditions for the `where` argument of the query `userOpportunities`. */
export type CodeUserOpportunitiesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<CodeUserOpportunitiesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<CodeUserOpportunitiesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<CodeUserOpportunitiesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<CodeUserOpportunitiesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `userOpportunities`. */
export type CodeUserOpportunitiesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<CodeUserOpportunitiesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type CodesConnection = {
  __typename?: 'CodesConnection';
  nodes: Array<Code>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateCodeInput = {
  captcha: Scalars['ID']['input'];
  /**
   * How many opportunities does the user
   * will get for this code.
   */
  category: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  invoice?: InputMaybe<InvoiceInput>;
  multiplier: Scalars['Int']['input'];
  options: Scalars['Int']['input'];
  visible?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateDeviceInput = {
  keys: DeviceKeys;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateWinnersForDrawInput = {
  /** Draw identifier. */
  id: Scalars['ID']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DateTimeRange = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteCodeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDeviceInput = {
  id: Scalars['ID']['input'];
};

export type Device = {
  __typename?: 'Device';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type DeviceKeys = {
  auth: Scalars['ID']['input'];
  p256dh: Scalars['ID']['input'];
};

export type Draw = {
  __typename?: 'Draw';
  area: Scalars['String']['output'];
  category: Scalars['String']['output'];
  excludeWinners: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * This key wont change, that way the clients can
   * show the prize with a specific presentation.
   * For example:
   * The draw category is "palanca-de-cambios" and
   * the key is "palanca-de-cambios-150m".
   */
  key?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Takes the users that has codes with the given range of codes. */
  participants: UserPaginator;
  /**
   * This range will be available for the draws that takes codes ranges, such as: draw#1
   * will have codes in the range 0-1_000, 2_001-3_000, draw#2 will have the
   * range 10_000-20_000, 30_000-40_000, 90_000-100_000.
   */
  ranges?: Maybe<Array<DrawRange>>;
  status: Scalars['Boolean']['output'];
  totalWinners: Scalars['Int']['output'];
  winners: WinnerPaginator;
};


export type DrawParticipantsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DrawParticipantsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type DrawWinnersArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of Draw items. */
export type DrawPaginator = {
  __typename?: 'DrawPaginator';
  /** A list of Draw items. */
  data: Array<Draw>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Allowed column names for Draw.participants.orderBy. */
export enum DrawParticipantsOrderByColumn {
  Id = 'ID'
}

/** Order by clause for Draw.participants.orderBy. */
export type DrawParticipantsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: DrawParticipantsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Inclusive ranges for the draw options. */
export type DrawRange = {
  __typename?: 'DrawRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type ExchangeAccountValidationCode = {
  code: Scalars['ID']['input'];
};

export type ExchangeOpportunityInput = {
  captcha: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  /**
   * When the exchange is done througth a QR code, the correlative
   * value is associated available.
   */
  correlative?: InputMaybe<Scalars['ID']['input']>;
};

export type ExternalOpportunities = {
  __typename?: 'ExternalOpportunities';
  data: Array<Opportunity>;
  paginatorInfo: ExternalOpportunitiesPaginatorInfo;
};

export type ExternalOpportunitiesPaginatorInfo = {
  __typename?: 'ExternalOpportunitiesPaginatorInfo';
  count: Scalars['Int']['output'];
  hasMorePages: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type ForgotPasswordInput = {
  captcha: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type ForgotPasswordOutput = {
  __typename?: 'ForgotPasswordOutput';
  message: Scalars['String']['output'];
};

export type IdentificationDocument = {
  __typename?: 'IdentificationDocument';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<IdentificationDocumentType>;
};

export type IdentificationDocumentInput = {
  /** The document number should be the ID. */
  id: Scalars['ID']['input'];
  /** The document type ID. */
  type: Scalars['ID']['input'];
};

export type IdentificationDocumentType = {
  __typename?: 'IdentificationDocumentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A paginated list of IdentificationDocumentType items. */
export type IdentificationDocumentTypePaginator = {
  __typename?: 'IdentificationDocumentTypePaginator';
  /** A list of IdentificationDocumentType items. */
  data: Array<IdentificationDocumentType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ImportChallenge = {
  __typename?: 'ImportChallenge';
  placeholder: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Amount;
  code: Scalars['ID']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identificationDocument?: Maybe<IdentificationDocument>;
};

export type InvoiceInput = {
  amount: Scalars['Float']['input'];
  code: Scalars['ID']['input'];
  documentNumber?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<Scalars['ID']['input']>;
};

export type JackpotOpportunities = {
  __typename?: 'JackpotOpportunities';
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type JackpotPrize = {
  __typename?: 'JackpotPrize';
  bonusIds?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalWinners: Scalars['Int']['output'];
};

export type JackpotPrizeDelivery = {
  __typename?: 'JackpotPrizeDelivery';
  /**
   * The JackpotPrize can have many bonus associated, this one
   * reffers to the bonus related to the received prize.
   */
  bonusIds?: Maybe<Array<Scalars['String']['output']>>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  prize: JackpotPrize;
  user?: Maybe<User>;
};

export type JackpotResult = {
  __typename?: 'JackpotResult';
  delivery?: Maybe<JackpotPrizeDelivery>;
  message: Scalars['String']['output'];
  playedAt?: Maybe<Scalars['Date']['output']>;
  remainingOpportunities: Scalars['Int']['output'];
  won: Scalars['Boolean']['output'];
};

export type LoginInput = {
  captcha: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginWithDocumentInput = {
  captcha: Scalars['ID']['input'];
  documentNumber: Scalars['String']['input'];
  documentType: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  applyCode: Opportunity;
  /**
   * The users that want to begin the registration process through a
   * third party provider, like google, should invoke this mutation.
   * When the authentication process is completed the user will be
   * redirected to the page at '/authentication/create-tokens' with
   * an additional argument in the query part called 'createTokenSetUrl'.
   * The client must to use this URL to create the access tokens.
   *
   * See diagram: 'Third Party Auth'.
   */
  authenticateWithThirdParty: AuthenticateWithThirdPartyOutput;
  clearDrawResult: Draw;
  createCode: Code;
  /**
   * Add a device to the user. This will be useful while sending
   * (web) push notifications.
   */
  createDevice?: Maybe<Device>;
  createWinnersForDraw: Draw;
  deleteCode: Code;
  /**
   * Deleted a created device from the user devices list. This
   * should be invoked while the user is logged out.
   */
  deleteDevice: Device;
  deleteUser: User;
  exchangeAccountValidationCode: User;
  exchangeOpportunity: OpportunityExchanged;
  forgotPassword: ForgotPasswordOutput;
  login: AuthenticationResult;
  loginWithDocument: AuthenticationResult;
  logout: Scalars['Boolean']['output'];
  playJackpot: JackpotResult;
  preLogin: PreLoginResult;
  /**
   * If the access token has expired the user should invoke this operation
   * to fetch a new access token.
   */
  refreshToken: AuthenticationTokens;
  register: AuthenticationResult;
  removeOpportunity: Opportunity;
  removeWinner: Draw;
  resetPassword: AuthenticationResult;
  sendAccountValidationMail: SendAccountValidationMailOutput;
  sendOTP: SendOtpResult;
  /** Update the user custom properties */
  setProfile: User;
  updateCallQueueItem: CallQueueItem;
  updateCode: Code;
  updateProfile: User;
  validateOTP: ValidateOtpResult;
};


export type MutationApplyCodeArgs = {
  input: ApplyCodeInput;
};


export type MutationAuthenticateWithThirdPartyArgs = {
  input: AuthenticateWithThirdPartyInput;
};


export type MutationClearDrawResultArgs = {
  input: ClearDrawResultInput;
};


export type MutationCreateCodeArgs = {
  input: CreateCodeInput;
};


export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};


export type MutationCreateWinnersForDrawArgs = {
  input: CreateWinnersForDrawInput;
};


export type MutationDeleteCodeArgs = {
  input: DeleteCodeInput;
};


export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExchangeAccountValidationCodeArgs = {
  input: ExchangeAccountValidationCode;
};


export type MutationExchangeOpportunityArgs = {
  input: ExchangeOpportunityInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginWithDocumentArgs = {
  input: LoginWithDocumentInput;
};


export type MutationPreLoginArgs = {
  input: PreLoginInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveOpportunityArgs = {
  input: RemoveOpportunityInput;
};


export type MutationRemoveWinnerArgs = {
  input: RemoveWinnerInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSendAccountValidationMailArgs = {
  input: SendAccountValidationMailInput;
};


export type MutationSendOtpArgs = {
  input: SendOtpInput;
};


export type MutationSetProfileArgs = {
  properties: Array<SetProfileInput>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCallQueueItemArgs = {
  input: UpdateCallQueueItemInput;
};


export type MutationUpdateCodeArgs = {
  input: UpdateCodeInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationValidateOtpArgs = {
  input: ValidateOtpInput;
};

export enum OtpVia {
  Mail = 'MAIL',
  Sms = 'SMS'
}

export type OperationResult = {
  __typename?: 'OperationResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * If the user have `limitedAccess` to the data, then the
 * following properties will be blank (null):
 * - code
 * - description
 * - createdAt
 */
export type Opportunity = {
  __typename?: 'Opportunity';
  /** Code or 'Added manually'. */
  category: OpportunityCategory;
  /**
   * The code associated with the opportunity can pertain to any
   * invoice, promotial code, gift or other relevan item.
   */
  code?: Maybe<Code>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * If the opportunity was added manually, the administrator should
   * ensure that the description is filled in.
   */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Label refers to the opportunity code. This was the user
   * input while exchanging and opportunity.
   */
  label: Scalars['String']['output'];
  multiplier: Scalars['Int']['output'];
  options: Scalars['Int']['output'];
  status: OpportunityStatus;
  /**
   * Owner of the opportunity. If the user was deleted this attribute
   * should be null.
   */
  user?: Maybe<User>;
};

export type OpportunityCategory = {
  __typename?: 'OpportunityCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OpportunityExchanged = {
  __typename?: 'OpportunityExchanged';
  id: Scalars['ID']['output'];
  station?: Maybe<Station>;
  status: OpportunityStatus;
  /**
   * If there are many available draws, the users can get it!
   * This list should be null if the module is not enabled.
   */
  won?: Maybe<Array<Draw>>;
};

/** A paginated list of Opportunity items. */
export type OpportunityPaginator = {
  __typename?: 'OpportunityPaginator';
  /** A list of Opportunity items. */
  data: Array<Opportunity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OpportunityStatus = {
  __typename?: 'OpportunityStatus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OwnsImportedDataInput = {
  answer: Scalars['String']['input'];
};

export type OwnsImportedDataOutput = {
  __typename?: 'OwnsImportedDataOutput';
  success: Scalars['Boolean']['output'];
  triesLeft: Scalars['Int']['output'];
  user?: Maybe<User>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PreLoginInput = {
  captcha: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type PreLoginResult = {
  __typename?: 'PreLoginResult';
  canContinue: Scalars['Boolean']['output'];
  code: PreLoginResultCode;
  message?: Maybe<Scalars['String']['output']>;
  redirectTo?: Maybe<Scalars['String']['output']>;
};

export enum PreLoginResultCode {
  /** The user is not registered. */
  NotAvailable = 'NOT_AVAILABLE',
  /** Can continue with the sign in process. */
  Ok = 'OK',
  /**
   * The user has been registered but the account
   * is pending for validation.
   */
  PendingAccountValidation = 'PENDING_ACCOUNT_VALIDATION'
}

export type Product = {
  __typename?: 'Product';
  amount: Amount;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum PropertyName {
  Birthday = 'BIRTHDAY',
  City = 'CITY',
  GasType = 'GAS_TYPE',
  Gender = 'GENDER',
  IpAddress = 'IP_ADDRESS',
  Notify = 'NOTIFY',
  Origin = 'ORIGIN',
  State = 'STATE',
  Vehicle = 'VEHICLE'
}

export type Query = {
  __typename?: 'Query';
  callsQueue: CallQueueItemPaginator;
  codeCategories: Array<CodeCategory>;
  codes: CodePaginator;
  draws: DrawPaginator;
  identificationDocumentTypes: IdentificationDocumentTypePaginator;
  me?: Maybe<User>;
  opportunities: OpportunityPaginator;
  roles: Array<Role>;
  sumCodeOptions: Scalars['Int']['output'];
  sumOptions: Scalars['Int']['output'];
  synchronizationSchedule: SynchronizationSchedule;
  /** Show the total amount of winners in the given draw category. */
  totalWinners: Scalars['Int']['output'];
  users: UserPaginator;
};


export type QueryCallsQueueArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryCallsQueueOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryCallsQueueWhereWhereConditions>;
};


export type QueryCodesArgs = {
  first?: Scalars['Int']['input'];
  hasInvoice?: InputMaybe<QueryCodesHasInvoiceWhereHasConditions>;
  orderBy?: InputMaybe<Array<QueryCodesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryCodesWhereWhereConditions>;
};


export type QueryDrawsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryDrawsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryDrawsWhereWhereConditions>;
};


export type QueryIdentificationDocumentTypesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunitiesArgs = {
  first?: Scalars['Int']['input'];
  hasCode?: InputMaybe<QueryOpportunitiesHasCodeWhereHasConditions>;
  orderBy?: InputMaybe<Array<QueryOpportunitiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QueryOpportunitiesWhereWhereConditions>;
};


export type QueryTotalWinnersArgs = {
  where: TotalWinnersInput;
};


export type QueryUsersArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryUsersOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  profileCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
};

/** Allowed column names for Query.callsQueue.orderBy. */
export enum QueryCallsQueueOrderByColumn {
  AddedAt = 'ADDED_AT',
  Id = 'ID'
}

/** Order by clause for Query.callsQueue.orderBy. */
export type QueryCallsQueueOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCallsQueueOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.callsQueue.where. */
export enum QueryCallsQueueWhereColumn {
  Status = 'STATUS',
  UserId = 'USER_ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `callsQueue`. */
export type QueryCallsQueueWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryCallsQueueWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryCallsQueueWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryCallsQueueWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryCallsQueueWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `callsQueue`. */
export type QueryCallsQueueWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryCallsQueueWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.codes.hasInvoice. */
export enum QueryCodesHasInvoiceColumn {
  Code = 'CODE',
  DocumentNumber = 'DOCUMENT_NUMBER',
  DocumentNumberTypeId = 'DOCUMENT_NUMBER_TYPE_ID'
}

/** Dynamic WHERE conditions for the `hasInvoice` argument of the query `codes`. */
export type QueryCodesHasInvoiceWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryCodesHasInvoiceWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryCodesHasInvoiceWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryCodesHasInvoiceWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryCodesHasInvoiceColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasInvoice` argument of the query `codes`. */
export type QueryCodesHasInvoiceWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryCodesHasInvoiceWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.codes.orderBy. */
export enum QueryCodesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.codes.orderBy. */
export type QueryCodesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCodesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.codes.where. */
export enum QueryCodesWhereColumn {
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  Label = 'LABEL',
  Status = 'STATUS',
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `codes`. */
export type QueryCodesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryCodesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryCodesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryCodesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryCodesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `codes`. */
export type QueryCodesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryCodesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.draws.orderBy. */
export enum QueryDrawsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for Query.draws.orderBy. */
export type QueryDrawsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryDrawsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.draws.where. */
export enum QueryDrawsWhereColumn {
  Category = 'CATEGORY',
  Enabled = 'ENABLED',
  Id = 'ID',
  Key = 'KEY',
  Name = 'NAME'
}

/** Dynamic WHERE conditions for the `where` argument of the query `draws`. */
export type QueryDrawsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryDrawsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryDrawsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryDrawsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryDrawsWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `draws`. */
export type QueryDrawsWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryDrawsWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.opportunities.hasCode. */
export enum QueryOpportunitiesHasCodeColumn {
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type QueryOpportunitiesHasCodeWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryOpportunitiesHasCodeWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryOpportunitiesHasCodeWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryOpportunitiesHasCodeWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryOpportunitiesHasCodeColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type QueryOpportunitiesHasCodeWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryOpportunitiesHasCodeWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type QueryOpportunitiesInput = {
  code?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<DateTimeRange>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

/** Allowed column names for Query.opportunities.orderBy. */
export enum QueryOpportunitiesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Options = 'OPTIONS'
}

/** Order by clause for Query.opportunities.orderBy. */
export type QueryOpportunitiesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryOpportunitiesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.opportunities.where. */
export enum QueryOpportunitiesWhereColumn {
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS',
  UserId = 'USER_ID',
  Uuid = 'UUID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `opportunities`. */
export type QueryOpportunitiesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryOpportunitiesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryOpportunitiesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryOpportunitiesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryOpportunitiesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `opportunities`. */
export type QueryOpportunitiesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryOpportunitiesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for Query.users.orderBy. */
export enum QueryUsersOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DocumentNumber = 'DOCUMENT_NUMBER',
  LastName = 'LAST_NAME',
  Name = 'NAME',
  OpportunityCount = 'OPPORTUNITY_COUNT'
}

/** Order by clause for Query.users.orderBy. */
export type QueryUsersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryUsersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.users.where. */
export enum QueryUsersWhereColumn {
  DocumentNumber = 'DOCUMENT_NUMBER',
  DocumentNumberTypeId = 'DOCUMENT_NUMBER_TYPE_ID',
  Email = 'EMAIL',
  Id = 'ID',
  LastName = 'LAST_NAME',
  Name = 'NAME',
  OpportunityCount = 'OPPORTUNITY_COUNT',
  ProfileUpdatedAt = 'PROFILE_UPDATED_AT',
  Role = 'ROLE'
}

/** Dynamic WHERE conditions for the `where` argument of the query `users`. */
export type QueryUsersWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryUsersWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryUsersWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryUsersWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryUsersWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `users`. */
export type QueryUsersWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryUsersWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  expiresIn: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
};

export type RefreshTokenInput = {
  token: Scalars['ID']['input'];
};

export type RegisterInput = {
  /** How much second passed before using the register operation? */
  acceptPrivacyPolicies: Scalars['Int']['input'];
  /** How much second passed before using the register operation? */
  acceptTermsAndConditions: Scalars['Int']['input'];
  captcha?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  /**
   * If the 'emailValidated' is set th true, then the email
   * sent to the user address with the 'validation' link
   * will be skipped. This will trigger the profile completion
   * with the legacy data.
   *
   * This should be used in the administrator context.
   */
  emailValidated?: InputMaybe<Scalars['Boolean']['input']>;
  identificationNumber?: InputMaybe<Scalars['ID']['input']>;
  identificationType?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * password should have a minimum length of 8 characteres. Should
   * have at least 1 uppercase, 1 lowercase, 1 number and 1 special
   * character.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * If the field 'profileUpdated' is false then user will need to update
   * his profile before interacting with the application API.
   *
   * This should be used in the administrator context.
   */
  profileUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If the field 'shouldCheckForeignData' is false then the legacy data will
   * be checked and if there is any match, the profile should be fulfilled.
   *
   * This should be used in the administrator context.
   */
  shouldCheckForeignData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveOpportunityInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type RemoveWinnerInput = {
  /** Winner identifier. */
  id: Scalars['ID']['input'];
};

export type ResetPasswordInput = {
  captcha: Scalars['ID']['input'];
  /** 'email' should be present in the mail that was sent. */
  email: Scalars['String']['input'];
  /**
   * password should have a minimum length of 6 characteres. No more
   * policies will be applied.
   */
  password: Scalars['String']['input'];
  /** 'token' is a key sent to the user email address. */
  token: Scalars['ID']['input'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

export type SendAccountValidationMailInput = {
  email: Scalars['String']['input'];
};

export type SendAccountValidationMailOutput = {
  __typename?: 'SendAccountValidationMailOutput';
  message: Scalars['String']['output'];
};

export type SendOtpInput = {
  via: OtpVia;
};

export type SendOtpResult = {
  __typename?: 'SendOTPResult';
  message: Scalars['String']['output'];
};

export type SetProfileInput = {
  label: PropertyName;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Station = {
  __typename?: 'Station';
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SynchronizationSchedule = {
  __typename?: 'SynchronizationSchedule';
  lastSynchronization?: Maybe<Scalars['DateTime']['output']>;
  nextSynchronization?: Maybe<Scalars['DateTime']['output']>;
};

export enum ThirdPartyProvider {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type TotalWinnersInput = {
  category: Scalars['String']['input'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateCallQueueItemInput = {
  id: Scalars['ID']['input'];
  status: Scalars['ID']['input'];
};

export type UpdateCodeInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoice?: InputMaybe<InvoiceInput>;
  multiplier?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['Int']['input']>;
  visible?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePasswordInput = {
  /**
   * The 'currentPassword' can de required if the authenticated user is trying
   * to update the password, otherwise, if an administrator is using this
   * mutation this property wont be required.
   */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  /**
   * password should have a minimum length of 6 characteres. No more
   * policies will be applied.
   */
  newPassword: Scalars['String']['input'];
};

export type UpdateProfileInput = {
  acceptPrivacyPolicies?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Some profile can be created from a signed URL, those users must to accept
   * the legal agreements; throught this properties this task can be completed.
   */
  acceptTermsAndConditions?: InputMaybe<Scalars['Int']['input']>;
  captcha?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identificationDocument?: InputMaybe<IdentificationDocumentInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<UpdatePasswordInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  __typename?: 'User';
  capabilities: Array<Capability>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Does the email address has been verified? */
  emailVerified: Scalars['Boolean']['output'];
  externalOpportunities?: Maybe<ExternalOpportunities>;
  id: Scalars['ID']['output'];
  identificationDocument?: Maybe<IdentificationDocument>;
  jackpotOpportunities: JackpotOpportunities;
  jackpotPrizeDeliveries: Array<JackpotPrizeDelivery>;
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * Users with limited access wont receive personal data. The following properties
   * wont be filled:
   * - name
   * - lastName
   * - email
   * - phoneNumber
   * - emailVerified
   * - shouldCheckForeignData
   * - passwordSet
   * - properties
   * - subscribedToNewsletter
   * - createdAt
   *
   * Cliens will get only the this fields:
   * - id
   * - identificationDocument
   * - termsAccepted
   * - profileUpdated
   * - opportunityCount
   * - capabilities
   * - opportunities
   */
  limitedAccess: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  opportunities: OpportunityPaginator;
  /**
   * Total amount of opportunities that belongs to the user.
   * It's the sum of the amount for every opportunity.
   */
  opportunityCount: Scalars['Int']['output'];
  /**
   * Users who signed up through a third-party provider will
   * need to update their password if they wish to proceed.
   */
  passwordSet: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * If this property is set to 'false', the user should
   * complete his profile to interact with the application.
   */
  profileUpdated: Scalars['Boolean']['output'];
  properties: UserPropertyPaginator;
  role: Role;
  /**
   * If this property is set to 'false', the user should
   * try to import their profile from the existing one.
   */
  shouldCheckForeignData: Scalars['Boolean']['output'];
  subscribedToNewsletter: Scalars['Boolean']['output'];
  /** Does the user already accept the terms and conditions? */
  termsAccepted: Scalars['Boolean']['output'];
  won: WinnerPaginator;
};


export type UserOpportunitiesArgs = {
  first?: Scalars['Int']['input'];
  hasCode?: InputMaybe<UserOpportunitiesHasCodeWhereHasConditions>;
  orderBy?: InputMaybe<Array<UserOpportunitiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserOpportunitiesWhereWhereConditions>;
};


export type UserPropertiesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type UserWonArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Allowed column names for User.opportunities.hasCode. */
export enum UserOpportunitiesHasCodeColumn {
  Type = 'TYPE'
}

/** Dynamic WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type UserOpportunitiesHasCodeWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<UserOpportunitiesHasCodeWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<UserOpportunitiesHasCodeWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<UserOpportunitiesHasCodeWhereHasConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<UserOpportunitiesHasCodeColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasCode` argument of the query `opportunities`. */
export type UserOpportunitiesHasCodeWhereHasConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<UserOpportunitiesHasCodeWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** Allowed column names for User.opportunities.orderBy. */
export enum UserOpportunitiesOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Order by clause for User.opportunities.orderBy. */
export type UserOpportunitiesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: UserOpportunitiesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for User.opportunities.where. */
export enum UserOpportunitiesWhereColumn {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS',
  Uuid = 'UUID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `opportunities`. */
export type UserOpportunitiesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<UserOpportunitiesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<UserOpportunitiesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<UserOpportunitiesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<UserOpportunitiesWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `opportunities`. */
export type UserOpportunitiesWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<UserOpportunitiesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserProperty = {
  __typename?: 'UserProperty';
  id: Scalars['ID']['output'];
  label: PropertyName;
  value: Scalars['String']['output'];
};

/** A paginated list of UserProperty items. */
export type UserPropertyPaginator = {
  __typename?: 'UserPropertyPaginator';
  /** A list of UserProperty items. */
  data: Array<UserProperty>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ValidateAccountInput = {
  token: Scalars['ID']['input'];
};

export type ValidateOtpInput = {
  code: Scalars['ID']['input'];
};

export type ValidateOtpResult = {
  __typename?: 'ValidateOTPResult';
  message: Scalars['String']['output'];
  user: User;
  valid: Scalars['Boolean']['output'];
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<WhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type Winner = {
  __typename?: 'Winner';
  createdAt: Scalars['DateTime']['output'];
  draw: Draw;
  id: Scalars['ID']['output'];
  opportunity?: Maybe<Opportunity>;
  priority: Scalars['Int']['output'];
  user: User;
};

/** A paginated list of Winner items. */
export type WinnerPaginator = {
  __typename?: 'WinnerPaginator';
  /** A list of Winner items. */
  data: Array<Winner>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SynchronizationScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type SynchronizationScheduleQuery = { __typename?: 'Query', synchronizationSchedule: { __typename?: 'SynchronizationSchedule', lastSynchronization?: any | null, nextSynchronization?: any | null } };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryUsersOrderByOrderByClause> | QueryUsersOrderByOrderByClause>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, lastPage: number }, data: Array<{ __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, opportunityCount: number, passwordSet: boolean, createdAt?: any | null, role: { __typename?: 'Role', id: string, name: string }, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null }> } };

export type UserDetailQueryVariables = Exact<{
  id: Scalars['Mixed']['input'];
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  where?: InputMaybe<UserOpportunitiesWhereWhereConditions>;
  orderBy?: InputMaybe<Array<UserOpportunitiesOrderByOrderByClause> | UserOpportunitiesOrderByOrderByClause>;
}>;


export type UserDetailQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, name?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, opportunityCount: number, subscribedToNewsletter: boolean, emailVerified: boolean, passwordSet: boolean, profileUpdated: boolean, createdAt?: any | null, role: { __typename?: 'Role', id: string, name: string }, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null, opportunities: { __typename?: 'OpportunityPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, lastPage: number }, data: Array<{ __typename?: 'Opportunity', id: string, label: string, options: number, multiplier: number, description?: string | null, createdAt?: any | null, code?: { __typename?: 'Code', id: string, invoice?: { __typename?: 'Invoice', amount: { __typename?: 'Amount', visible: string } } | null } | null, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string }, category: { __typename?: 'OpportunityCategory', id: string, name: string } }> } }> } };

export type CountUsersQueryVariables = Exact<{
  profileCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CountUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null } };

export type CountOpportunitiesQueryVariables = Exact<{
  valid?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CountOpportunitiesQuery = { __typename?: 'Query', sumOptions: number, sumCodeOptions: number, opportunities: { __typename?: 'OpportunityPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

export type OpportunitiesForUserQueryVariables = Exact<{
  where?: InputMaybe<QueryOpportunitiesWhereWhereConditions>;
}>;


export type OpportunitiesForUserQuery = { __typename?: 'Query', opportunities: { __typename?: 'OpportunityPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number }, data: Array<{ __typename?: 'Opportunity', id: string, label: string, options: number, multiplier: number, description?: string | null, createdAt?: any | null, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string }, category: { __typename?: 'OpportunityCategory', id: string, name: string } }> } };

export type RemoveOpportunityMutationVariables = Exact<{
  input: RemoveOpportunityInput;
}>;


export type RemoveOpportunityMutation = { __typename?: 'Mutation', removeOpportunity: { __typename?: 'Opportunity', id: string, label: string, user?: { __typename?: 'User', id: string, name?: string | null } | null } };

export type CodesQueryVariables = Exact<{
  where?: InputMaybe<QueryCodesWhereWhereConditions>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryCodesOrderByOrderByClause> | QueryCodesOrderByOrderByClause>;
}>;


export type CodesQuery = { __typename?: 'Query', codes: { __typename?: 'CodePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, lastPage: number }, data: Array<{ __typename?: 'Code', id: string, label: string, options: number, multiplier: number, type: { __typename?: 'CodeCategory', id: string, name: string } }> } };

export type CreateCodeMutationVariables = Exact<{
  input: CreateCodeInput;
}>;


export type CreateCodeMutation = { __typename?: 'Mutation', createCode: { __typename?: 'Code', id: string, label: string, options: number, multiplier: number, type: { __typename?: 'CodeCategory', id: string, name: string } } };

export type CreateUserMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthenticationResult', user: { __typename?: 'User', id: string, email?: string | null, name?: string | null, lastName?: string | null, emailVerified: boolean, profileUpdated: boolean, role: { __typename?: 'Role', id: string } } } };

export type FindCodeQueryVariables = Exact<{
  id: Scalars['Mixed']['input'];
  where?: InputMaybe<CodeOpportunitiesWhereWhereConditions>;
  orderBy?: InputMaybe<Array<CodeOpportunitiesOrderByOrderByClause> | CodeOpportunitiesOrderByOrderByClause>;
}>;


export type FindCodeQuery = { __typename?: 'Query', codes: { __typename?: 'CodePaginator', data: Array<{ __typename?: 'Code', id: string, label: string, options: number, multiplier: number, createdAt?: any | null, type: { __typename?: 'CodeCategory', id: string, name: string }, invoice?: { __typename?: 'Invoice', id: string, amount: { __typename?: 'Amount', value: number, visible: string }, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string, label: string, options: number, multiplier: number, description?: string | null, createdAt?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null } | null, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string }, category: { __typename?: 'OpportunityCategory', id: string, name: string } }> }> } };

export type CreateDeviceMutationVariables = Exact<{
  input: CreateDeviceInput;
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createDevice?: { __typename?: 'Device', id: string } | null };

export type DeleteDeviceMutationVariables = Exact<{
  input: DeleteDeviceInput;
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice: { __typename?: 'Device', id: string } };

export type FullWinnerPartFragment = { __typename?: 'Winner', id: string, priority: number, user: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, opportunityCount: number, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null }, opportunity?: { __typename?: 'Opportunity', id: string, label: string, code?: { __typename?: 'Code', id: string, station?: string | null, area?: string | null } | null } | null } & { ' $fragmentName'?: 'FullWinnerPartFragment' };

export type DrawsQueryVariables = Exact<{
  where?: InputMaybe<QueryDrawsWhereWhereConditions>;
  orderBy?: InputMaybe<Array<QueryDrawsOrderByOrderByClause> | QueryDrawsOrderByOrderByClause>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DrawsQuery = { __typename?: 'Query', draws: { __typename?: 'DrawPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, lastPage: number }, data: Array<{ __typename?: 'Draw', id: string, name: string, status: boolean, category: string, winners: { __typename?: 'WinnerPaginator', data: Array<(
          { __typename?: 'Winner' }
          & { ' $fragmentRefs'?: { 'FullWinnerPartFragment': FullWinnerPartFragment } }
        )> } }> } };

export type CreateWinnersForDrawMutationVariables = Exact<{
  input: CreateWinnersForDrawInput;
}>;


export type CreateWinnersForDrawMutation = { __typename?: 'Mutation', createWinnersForDraw: { __typename?: 'Draw', id: string, status: boolean, winners: { __typename?: 'WinnerPaginator', data: Array<(
        { __typename?: 'Winner' }
        & { ' $fragmentRefs'?: { 'FullWinnerPartFragment': FullWinnerPartFragment } }
      )> } } };

export type ClearDrawResultMutationVariables = Exact<{
  input: ClearDrawResultInput;
}>;


export type ClearDrawResultMutation = { __typename?: 'Mutation', clearDrawResult: { __typename?: 'Draw', id: string, status: boolean, winners: { __typename?: 'WinnerPaginator', data: Array<(
        { __typename?: 'Winner' }
        & { ' $fragmentRefs'?: { 'FullWinnerPartFragment': FullWinnerPartFragment } }
      )> } } };

export type RemoveWinnerMutationVariables = Exact<{
  input: RemoveWinnerInput;
}>;


export type RemoveWinnerMutation = { __typename?: 'Mutation', removeWinner: { __typename?: 'Draw', id: string, winners: { __typename?: 'WinnerPaginator', data: Array<(
        { __typename?: 'Winner' }
        & { ' $fragmentRefs'?: { 'FullWinnerPartFragment': FullWinnerPartFragment } }
      )> } } };

export type DrawDetailsQueryVariables = Exact<{
  where?: InputMaybe<QueryDrawsWhereWhereConditions>;
  participants?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DrawDetailsQuery = { __typename?: 'Query', draws: { __typename?: 'DrawPaginator', data: Array<{ __typename?: 'Draw', id: string, name: string, status: boolean, category: string, ranges?: Array<{ __typename?: 'DrawRange', min: number, max: number }> | null, winners: { __typename?: 'WinnerPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, lastPage: number }, data: Array<(
          { __typename?: 'Winner' }
          & { ' $fragmentRefs'?: { 'FullWinnerPartFragment': FullWinnerPartFragment } }
        )> }, participants: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, name?: string | null, lastName?: string | null, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null }> } }> } };

export type PrizesQueryVariables = Exact<{ [key: string]: never; }>;


export type PrizesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, won: { __typename?: 'WinnerPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, lastPage: number }, data: Array<{ __typename?: 'Winner', id: string, draw: { __typename?: 'Draw', id: string, category: string } }> } } | null };

export type OpportunityCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityCountQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, opportunityCount: number } | null };

export type OportunitiesQueryVariables = Exact<{
  input?: InputMaybe<UserOpportunitiesWhereWhereConditions>;
  codes?: InputMaybe<UserOpportunitiesHasCodeWhereHasConditions>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOpportunitiesOrderByOrderByClause> | UserOpportunitiesOrderByOrderByClause>;
}>;


export type OportunitiesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null, opportunityCount: number, opportunities: { __typename?: 'OpportunityPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number, hasMorePages: boolean }, data: Array<{ __typename?: 'Opportunity', id: string, options: number, label: string, multiplier: number, description?: string | null, createdAt?: any | null, code?: { __typename?: 'Code', id: string, visible?: Array<string | null> | null, description?: string | null, station?: string | null, products?: Array<{ __typename?: 'Product', id: string, name: string, amount: { __typename?: 'Amount', value: number } }> | null, invoice?: { __typename?: 'Invoice', id: string, code: string, date?: any | null, amount: { __typename?: 'Amount', value: number, visible: string } } | null } | null, category: { __typename?: 'OpportunityCategory', id: string, name: string }, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string } }> } } | null };

export type ExchangeOpportunityMutationVariables = Exact<{
  input: ExchangeOpportunityInput;
}>;


export type ExchangeOpportunityMutation = { __typename?: 'Mutation', exchangeOpportunity: { __typename?: 'OpportunityExchanged', id: string, station?: { __typename?: 'Station', id: string, name: string, city?: string | null } | null, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string }, won?: Array<{ __typename?: 'Draw', id: string, name: string, category: string, key?: string | null }> | null } };

export type GetOpportunitiesQueryVariables = Exact<{
  where?: InputMaybe<QueryOpportunitiesWhereWhereConditions>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryOpportunitiesOrderByOrderByClause> | QueryOpportunitiesOrderByOrderByClause>;
}>;


export type GetOpportunitiesQuery = { __typename?: 'Query', opportunities: { __typename?: 'OpportunityPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, total: number } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, profileUpdated: boolean, emailVerified: boolean, termsAccepted: boolean, passwordSet: boolean, limitedAccess: boolean, role: { __typename?: 'Role', id: string, name: string }, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null } | null };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, passwordSet: boolean, profileUpdated: boolean, emailVerified: boolean, subscribedToNewsletter: boolean, limitedAccess: boolean, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null, properties: { __typename?: 'UserPropertyPaginator', data: Array<{ __typename?: 'UserProperty', id: string, label: PropertyName, value: string }> } } | null };

export type AuthenticateWithThirdPartyMutationVariables = Exact<{
  input: AuthenticateWithThirdPartyInput;
}>;


export type AuthenticateWithThirdPartyMutation = { __typename?: 'Mutation', authenticateWithThirdParty: { __typename?: 'AuthenticateWithThirdPartyOutput', redirectTo: string } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordOutput', message: string } };

export type PreLoginMutationVariables = Exact<{
  input: PreLoginInput;
}>;


export type PreLoginMutation = { __typename?: 'Mutation', preLogin: { __typename?: 'PreLoginResult', message?: string | null, canContinue: boolean, code: PreLoginResultCode, redirectTo?: string | null } };

export type SendAccountValidationMailMutationVariables = Exact<{
  input: SendAccountValidationMailInput;
}>;


export type SendAccountValidationMailMutation = { __typename?: 'Mutation', sendAccountValidationMail: { __typename?: 'SendAccountValidationMailOutput', message: string } };

export type SetProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  properties: Array<SetProfileInput> | SetProfileInput;
}>;


export type SetProfileMutation = { __typename?: 'Mutation', setProfile: { __typename?: 'User', id: string, properties: { __typename?: 'UserPropertyPaginator', data: Array<{ __typename?: 'UserProperty', label: PropertyName, value: string }> } } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, passwordSet: boolean, termsAccepted: boolean, profileUpdated: boolean, emailVerified: boolean, subscribedToNewsletter: boolean, limitedAccess: boolean, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null, properties: { __typename?: 'UserPropertyPaginator', data: Array<{ __typename?: 'UserProperty', id: string, label: PropertyName, value: string }> } } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AuthenticationResult', user: { __typename?: 'User', id: string, passwordSet: boolean, emailVerified: boolean, profileUpdated: boolean } } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthenticationResult', user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, limitedAccess: boolean, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', name: string } | null } | null } } };

export type ExchangeAccountValidationCodeMutationVariables = Exact<{
  input: ExchangeAccountValidationCode;
}>;


export type ExchangeAccountValidationCodeMutation = { __typename?: 'Mutation', exchangeAccountValidationCode: { __typename?: 'User', email?: string | null } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthenticationResult', user: { __typename?: 'User', id: string, email?: string | null, name?: string | null, lastName?: string | null, emailVerified: boolean, profileUpdated: boolean, termsAccepted: boolean, role: { __typename?: 'Role', id: string, name: string } } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ExchangeVerificationCodeMutationVariables = Exact<{
  input: ExchangeAccountValidationCode;
}>;


export type ExchangeVerificationCodeMutation = { __typename?: 'Mutation', exchangeAccountValidationCode: { __typename?: 'User', id: string, emailVerified: boolean } };

export type LoginWithDocumentMutationVariables = Exact<{
  input: LoginWithDocumentInput;
}>;


export type LoginWithDocumentMutation = { __typename?: 'Mutation', loginWithDocument: { __typename?: 'AuthenticationResult', user: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, emailVerified: boolean, opportunityCount: number, termsAccepted: boolean, profileUpdated: boolean, limitedAccess: boolean, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null } } };

export type SendOtpMutationVariables = Exact<{
  input: SendOtpInput;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOTP: { __typename?: 'SendOTPResult', message: string } };

export type ValidateOtpMutationVariables = Exact<{
  input: ValidateOtpInput;
}>;


export type ValidateOtpMutation = { __typename?: 'Mutation', validateOTP: { __typename?: 'ValidateOTPResult', valid: boolean, message: string, user: { __typename?: 'User', id: string, name?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, profileUpdated: boolean, emailVerified: boolean, termsAccepted: boolean, passwordSet: boolean, limitedAccess: boolean, role: { __typename?: 'Role', id: string, name: string }, identificationDocument?: { __typename?: 'IdentificationDocument', id?: string | null, type?: { __typename?: 'IdentificationDocumentType', id: string, name: string } | null } | null } } };

export type OppFragmentFragment = { __typename: 'Opportunity', id: string, options: number, label: string, multiplier: number, description?: string | null, createdAt?: any | null, code?: { __typename?: 'Code', id: string, visible?: Array<string | null> | null, description?: string | null, station?: string | null, products?: Array<{ __typename?: 'Product', id: string, name: string, amount: { __typename?: 'Amount', value: number } }> | null, invoice?: { __typename?: 'Invoice', id: string, code: string, date?: any | null, amount: { __typename?: 'Amount', value: number, visible: string } } | null } | null, category: { __typename?: 'OpportunityCategory', id: string, name: string }, status: { __typename?: 'OpportunityStatus', id: string, name: string, type: string } } & { ' $fragmentName'?: 'OppFragmentFragment' };

export const FullWinnerPartFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<FullWinnerPartFragment, unknown>;
export const OppFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OppFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Opportunity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<OppFragmentFragment, unknown>;
export const SynchronizationScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"synchronizationSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"synchronizationSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSynchronization"}},{"kind":"Field","name":{"kind":"Name","value":"nextSynchronization"}}]}}]}}]} as unknown as DocumentNode<SynchronizationScheduleQuery, SynchronizationScheduleQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryUsersWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryUsersOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const UserDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Mixed"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOpportunitiesWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOpportunitiesOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"ID"}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscribedToNewsletter"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailQuery, UserDetailQueryVariables>;
export const CountUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileCompleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profileCompleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileCompleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<CountUsersQuery, CountUsersQueryVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const CountOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"valid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valid"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sumOptions"}},{"kind":"Field","name":{"kind":"Name","value":"sumCodeOptions"}}]}}]} as unknown as DocumentNode<CountOpportunitiesQuery, CountOpportunitiesQueryVariables>;
export const OpportunitiesForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunitiesForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOpportunitiesWhereWhereConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<OpportunitiesForUserQuery, OpportunitiesForUserQueryVariables>;
export const RemoveOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveOpportunityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveOpportunityMutation, RemoveOpportunityMutationVariables>;
export const CodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"codes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryCodesWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryCodesOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CodesQuery, CodesQueryVariables>;
export const CreateCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCodeMutation, CreateCodeMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const FindCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Mixed"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CodeOpportunitiesWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CodeOpportunitiesOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"ID"}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindCodeQuery, FindCodeQueryVariables>;
export const CreateDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const DeleteDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteDeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const DrawsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"draws"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryDrawsWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryDrawsOrderByOrderByClause"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draws"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullWinnerPart"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<DrawsQuery, DrawsQueryVariables>;
export const CreateWinnersForDrawDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWinnersForDraw"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWinnersForDrawInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWinnersForDraw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullWinnerPart"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<CreateWinnersForDrawMutation, CreateWinnersForDrawMutationVariables>;
export const ClearDrawResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"clearDrawResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClearDrawResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearDrawResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullWinnerPart"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<ClearDrawResultMutation, ClearDrawResultMutationVariables>;
export const RemoveWinnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeWinner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveWinnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeWinner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullWinnerPart"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveWinnerMutation, RemoveWinnerMutationVariables>;
export const DrawDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"drawDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryDrawsWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draws"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"winners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullWinnerPart"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participants"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"ID"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullWinnerPart"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Winner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode<DrawDetailsQuery, DrawDetailsQueryVariables>;
export const PrizesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"prizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"won"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"StringValue","value":"palanca_de_cambios","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"draw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrizesQuery, PrizesQueryVariables>;
export const OpportunityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}}]}}]}}]} as unknown as DocumentNode<OpportunityCountQuery, OpportunityCountQueryVariables>;
export const OportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"oportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOpportunitiesWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOpportunitiesHasCodeWhereHasConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOpportunitiesOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codes"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"station"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OportunitiesQuery, OportunitiesQueryVariables>;
export const ExchangeOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exchangeOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExchangeOpportunityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"station"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"won"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<ExchangeOpportunityMutation, ExchangeOpportunityMutationVariables>;
export const GetOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOpportunitiesWhereWhereConditions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOpportunitiesOrderByOrderByClause"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"valid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valid"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"termsAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"subscribedToNewsletter"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const AuthenticateWithThirdPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authenticateWithThirdParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateWithThirdPartyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticateWithThirdParty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectTo"}}]}}]}}]} as unknown as DocumentNode<AuthenticateWithThirdPartyMutation, AuthenticateWithThirdPartyMutationVariables>;
export const ForgotPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ForgotPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const PreLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"preLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"canContinue"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"redirectTo"}}]}}]}}]} as unknown as DocumentNode<PreLoginMutation, PreLoginMutationVariables>;
export const SendAccountValidationMailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendAccountValidationMail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendAccountValidationMailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAccountValidationMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SendAccountValidationMailMutation, SendAccountValidationMailMutationVariables>;
export const SetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"properties"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetProfileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"properties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"properties"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetProfileMutation, SetProfileMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"termsAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"subscribedToNewsletter"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}}]}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ExchangeAccountValidationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exchangeAccountValidationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExchangeAccountValidationCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeAccountValidationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ExchangeAccountValidationCodeMutation, ExchangeAccountValidationCodeMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"termsAccepted"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ExchangeVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exchangeVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExchangeAccountValidationCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeAccountValidationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<ExchangeVerificationCodeMutation, ExchangeVerificationCodeMutationVariables>;
export const LoginWithDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"loginWithDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginWithDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}}]}}]}}]}}]} as unknown as DocumentNode<LoginWithDocumentMutation, LoginWithDocumentMutationVariables>;
export const SendOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendOTPInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SendOtpMutation, SendOtpMutationVariables>;
export const ValidateOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateOTPInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"profileUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"termsAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"}},{"kind":"Field","name":{"kind":"Name","value":"limitedAccess"}},{"kind":"Field","name":{"kind":"Name","value":"identificationDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ValidateOtpMutation, ValidateOtpMutationVariables>;